import { render, staticRenderFns } from "./TemplateDate.vue?vue&type=template&id=74474188&"
import script from "./TemplateDate.vue?vue&type=script&lang=js&"
export * from "./TemplateDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports